module.exports = __webpack_public_path__ + "static/assets/85132252ad7da1484db6ddc8a26a9f88.svg";